import { Component, Input, OnInit } from '@angular/core';
import { Categorie, ModelliStampaService } from '../../../services/modelli-stampa.service';

@Component({
  selector: 'app-griglia-modelli',
  templateUrl: './griglia-modelli.component.html',
  styles: [
  ]
})
export class GrigliaModelliComponent implements OnInit {

  @Input() itemData:any;
  @Input() idCategoriaModello?:string = this.modelliStampaService.getCategorie().FORMULARI;
  constructor(private modelliStampaService:ModelliStampaService) { }

  ngOnInit(): void {
  }

  async onOptionalButtonClick(evt){

    //console.warn(evt);

    

    if(evt.name == 'stampaModello' && this.itemData[0]['dati'])
    {
      //console.warn(this.itemData[0]['dati']);

      if (this.idCategoriaModello ==  Categorie.FORMULARI)
        for (let key of Object.keys(this.itemData[0]['dati'])) {
          
          if (key == 'idStatoFisico' && this.itemData[0]['dati'][key]) {

            let statoFisicoDescrizione = await this.modelliStampaService.getStatoFisicoById(this.itemData[0]['dati'][key]);

            this.itemData[0]['dati']['statoFisico_Descrizione'] = statoFisicoDescrizione;

            break;
          }/*
          else if (obj['IdStatoFisico']) {


            let statoFisicoDescrizione = await this.modelliStampaService.getStatoFisicoById(obj['IdStatoFisico']);





            obj['StatoFisico_Descrizione'] = statoFisicoDescrizione;

          }
          */
        }
      
      this.modelliStampaService.generaPDF([this.itemData[0]['dati']],evt.row.data.id,'preview')


    }
    //console.warn(this.itemData);
  }

  onModelloSelected(evt){

    //console.warn(evt);
    //console.warn(this.itemData);

  }

  onAllEvent(evt){
    // console.warn(evt);
    // console.warn(this.itemData);

  }

  /*
  onSelezioneRiga(evt:any[]){

    console.log(evt);

  }
  */
}
